// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vTRBqYsMTrwAp0MsaQho{border-bottom:1px solid var(--interaction-neutral-normal);margin-top:26px;padding-bottom:32px}.vTRBqYsMTrwAp0MsaQho input{color:var(--content-primary-secondary);font-weight:400}.C1IYblcNfw6TUxAL4Ntu,.vTRBqYsMTrwAp0MsaQho{gap:8px}.C1IYblcNfw6TUxAL4Ntu>div{align-items:flex-start}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"keywordDescription": `vTRBqYsMTrwAp0MsaQho`,
	"keywordName": `C1IYblcNfw6TUxAL4Ntu`
};
export default ___CSS_LOADER_EXPORT___;
